import type { SVGProps } from 'react'

const SvgSingleVirtualSensorFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' {...props}>
    <path d='M7.99 2A2.99 2.99 0 0 0 5 4.99h1.4c0-.878.712-1.59 1.59-1.59zM9.71 2v1.4h4.582V2zm6.3 0v1.4c.88 0 1.59.712 1.59 1.59H19A2.99 2.99 0 0 0 16.01 2M12 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-7 .709v4.582h1.4V6.709zm12.6 0v4.582H19V6.709zM5 13.009A2.99 2.99 0 0 0 7.99 16v-1.4a1.59 1.59 0 0 1-1.59-1.59zm12.6 0a1.59 1.59 0 0 1-1.59 1.59V16A2.99 2.99 0 0 0 19 13.01zM9.71 14.6V16H11v5a1 1 0 1 0 2 0v-5h1.291v-1.4z' />
  </svg>
)

export default SvgSingleVirtualSensorFilled
